import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";
// component

// utils
import { isValidElementType, isElement } from "../../utils/reactHelper";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPopover-paper": {
    minWidth: "100px",
  },
}));

const renderMenuItem = (menuItems) => {
  if (Array.isArray(menuItems)) {
    return menuItems
      .filter((item) => isElement(item.children))
      .map(
        ({ children, useMenuItem = true, ...rest }, idx) =>
          (useMenuItem === false && (
            <div key={idx.toString()}>{children}</div>
          )) || (
            <MenuItem key={idx.toString()} {...rest}>
              {children}
            </MenuItem>
          )
      );
  }
  if (isElement(menuItems)) {
    return menuItems;
  }
  return null;
};

//
const IconPopup = ({
  icon,
  iconButtonProps,
  menuProps,
  editSubmitFlag,
  setEditSubmitFlag,
}) => {
  // style
  const classes = useStyles();
  // props
  const { onButtonIconClick, ...restIconBtnProps } = iconButtonProps;
  const { header, body, footer, onClose, ...restMenuProps } = menuProps;

  // local state
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (onButtonIconClick) onButtonIconClick(event);
  };
  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) onClose();
    setEditSubmitFlag(false);
  };

  useEffect(() => {
    if (editSubmitFlag) {
      handleClose();
    }
  }, [editSubmitFlag]);

  return (
    <>
      <IconButton {...restIconBtnProps} onClick={handleClick}>
        {icon}
      </IconButton>

      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        {...restMenuProps}
      >
        {header && renderMenuItem(header)}
        {header && body && <Divider />}
        {body && renderMenuItem(body)}
        {body && footer && <Divider />}
        {footer && renderMenuItem(footer)}
      </StyledMenu>
    </>
  );
};

IconPopup.propTypes = {
  icon: PropTypes.node,
  iconButtonProps: PropTypes.objectOf(PropTypes.any),
  menuProps: PropTypes.objectOf(PropTypes.any),
  editSubmitFlag: PropTypes.bool,
  setEditSubmitFlag: PropTypes.func,
};

IconPopup.defaultProps = {
  icon: null,
  iconButtonProps: {},
  menuProps: {},
  editSubmitFlag: false,
  setEditSubmitFlag: () => {},
};

export default IconPopup;
